export const messages = {
  title: 'User Management',
};
